import { ThemeProvider } from "@material-ui/core";
import React from "react";

export default function ThemeHOC({ component, themeObj }) {
    return <ThemeProvider theme={themeObj}>{component}</ThemeProvider>;
}
